export const loginReqData = {
  "email": "",
  "password": ""
}